export default "This booking will be moved to requested.\n\nAre you sure you want to request this booking?"